import * as Search from '../constants/Search';
import axios from 'axios';
import '../constants/AppSettings'
import * as SG from '../constants/AppSettings'
import { loadStart, loadEnd, noticeAdd } from './App'

export function searchCommunity(formData) {
  return dispatch => {
    dispatch(loadStart())
    axios.get(SG.COMMUNITY_INDEX_URL, {
        params: formData
      }).then(response => {
      dispatch(searchCommunityResult(response.data));
      dispatch(loadEnd())

      return {
        type: Search.SEARCH_COMMUNITY
      }
    }).catch(response => {
      dispatch(loadEnd())
      dispatch(noticeAdd('検索に失敗しました','error'))
      return {
        type: Search.SEARCH_COMMUNITY
      }
    })
  }
}

export function searchCommunityResult(communities) {
  return {
    type: Search.SEARCH_COMMUNITY_RESULT,
    communities
  }
}

export function searchCommunityResultRemove() {
  return {
    type: Search.SEARCH_COMMUNITY_RESULT_REMOVE
  }
}


// WEBPACK FOOTER //
// ./src/actions/Search.js